var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('admin.molecules.edit.title'))+" ")]},proxy:true}])},[(_vm.molecule)?_c('molecule-form',{key:_vm.molecule.id,staticClass:"py-4 px-4",attrs:{"molecule":_vm.molecule,"persist":_vm.onPersist},on:{"change":_vm.onChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }